import {
Component,
EventEmitter,
Injector,
Input,
OnChanges,
OnInit,
Output,
SimpleChanges,
} from '@angular/core';
import {
WFStepConfig,
WFTaskConfig,
WFComponent,
WFTableConfig,
WfSignature,
} from '../../workflow';
import { BaseComponent } from 'src/app/common/base/base.component';
import {
CdkDragDrop,
moveItemInArray,
transferArrayItem,
} from '@angular/cdk/drag-drop';
import { Subscription } from 'rxjs';
import { WorkFlowService } from '../../workflow.service';
import { ClEditorComponent } from 'src/app/controls/checklist-components/cl-editor/cl-editor.component';

@Component({
  selector: 'workflow-tasks',
  templateUrl: './workflow-tasks.component.html',
  styleUrls: ['./workflow-tasks.component.scss'],
})
export class WorkflowTasksComponent
  extends BaseComponent
  implements OnChanges, OnInit {
  @Input() step?: WFStepConfig;
  @Input() disabled?: boolean;
  @Input() wfTableConfig?: WFTableConfig;
  @Input() stepDropLists!: string[];

  @Output() refreshPreviousStep = new EventEmitter<number>();

  tasks?: WFTaskConfig[];

  component?: WFComponent;
  components?: WFComponent[];
  componentsSubs!: Subscription;

  dragging?: boolean;

  trackByTaskId = (_: number, t: any) => t?.id ?? _;

  constructor(
    protected override injector: Injector,
    public service: WorkFlowService
  ) {
    super(injector);
  }

  ngOnInit(): void { }

  ngOnChanges(changes: SimpleChanges): void {
    this.loadComponents();
    this.tasks = this.step?.wfTaskConfigs?.sort((a, b) =>
      this.utils.sort(a.order, b.order)
    );
    this.tasks?.map(
      (t) => (t.component = this.components?.find((c) => c.id == t.type))
    );
    this.reorder();
  }

  loadComponents() {
    this.componentsSubs = this.store
      .select((state) => state.Components.data)
      .subscribe((data) => {
        if (data?.length) this.components = data;
      });
  }

  addTaskDialog() {
    const s = {} as WfSignature;
    const editor = this.dialog.open(ClEditorComponent, {
      maxHeight: window.innerHeight + 'px',
      maxWidth: '100%',
      minWidth: '60%',
      panelClass: 'draggable-dialog',
      data: {
        s,
        wfTableConfigID: this.wfTableConfig?.id,
        formType: this.wfTableConfig?.formType,
        serialNo: 'Template',
        roles: [],
        disabled: false,
      },
      disableClose: true,
      autoFocus: false,
      hasBackdrop: true,
    });
    editor.afterClosed().subscribe((data) => {
      if (data) {
        if (!this.tasks) this.tasks = [];
        const maxNumber = !this.tasks?.length
          ? -1
          : Math.max(...this.tasks.map((s) => s.order ?? 0));
        const task = this.service.getTaskConfigFromSignature(data.s);
        task.order = maxNumber + 1;
        task.wfStepConfigID = this.step?.id;
        this.tasks.push(task);
        this.reorder();
      }
    });
  }

  delete(s: WFTaskConfig) {
    const index = this.tasks?.indexOf(s);
    if (index !== undefined && index > -1) {
      this.tasks?.splice(index, 1);
    }
    this.reorder();
  }

  duplicate(s: WFTaskConfig) {
    const task = this.utils.cloneDeep(s);
    task.id = 0;
    task.wfActionConfigs?.forEach((a) => (a.id = 0));
    task.wfRoleConfigs?.forEach((r) => (r.id = 0));
    this.tasks?.push(task);
    this.reorder();
  }

  change(s: WFTaskConfig) {
    const index = this.tasks?.findIndex((task) => task.id === s.id);
    if (index !== undefined && index > -1) {
      this.tasks![index] = s;
    }
    this.reorder();
  }

  drop(event: CdkDragDrop<WFTaskConfig[] | undefined>) {
    if (event.previousContainer === event.container && this.tasks) {
      moveItemInArray(
        event.container.data ?? [],
        event.previousIndex,
        event.currentIndex
      );
      // moveItemInArray(this.tasks, event.previousIndex, event.currentIndex);
      this.reorder();
    } else {
      const stepID = event.container?.id?.replace('step-', '');
      const task = event.previousContainer?.data?.[event.previousIndex];
      const previosStepID = task?.wfStepConfigID;
      task!.wfStepConfigID = +stepID;
      transferArrayItem(
        event.previousContainer.data as WFTaskConfig[],
        event.container.data as WFTaskConfig[],
        event.previousIndex,
        event.currentIndex
      );
      this.reorder();
      this.refreshPreviousStep.emit(previosStepID);
    }
  }

  reorder() {
    let order = 0;
    let number = 1;
    this.tasks?.forEach((s) => {
      s.order = order;
      order++;
      if (s.component?.numericHeader) {
        s.name = number.toString();
        number++;
      }
    });
    this.step!.wfTaskConfigs = this.tasks ?? [];
  }

  checkDFlex() {
    return !this.tasks?.some((t) => t.component?.fullWidth);
  }

  checkDFlexWrap() {
    if (this.tasks)
      return (
        this.tasks?.some((t) => t.component?.fullWidth) || this.tasks.length > 5
      );
    return false;
  }
}
